'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  question: 'The long and the short of it',
  info: 'Please select 1',
  answers: [{
    label: 'I\u2019m a long hair lover \u2013 the longer the better',
    value: '',
    checked: false
  }, {
    label: 'I like my hair longer, but not so long that it\u2019s hard to style',
    value: '',
    checked: false
  }, {
    label: 'I\'m more of a mid-length woman  \u2013 the minute it starts to hit my shoulders, I go for the chop',
    value: '',
    checked: false
  }, {
    label: 'Short all the way \u2013 it suits me and my lifestyle',
    value: '',
    checked: false
  }],
  maxAnswers: 1,
  layout: 'single',
  colour: 'grey'
}, {
  question: 'If my hair was a fabric, it would be:',
  info: 'Please select 1',
  answers: [{
    label: 'Silk \u2013 fine texture',
    value: 'Pitta',
    checked: false
  }, {
    label: 'Satin \u2013 lots of hair, though fine in texture',
    value: 'Kapha',
    checked: false
  }, {
    label: 'Cotton \u2013 medium texture',
    value: 'Vata',
    checked: false
  }, {
    label: 'Wool \u2013 thick texture',
    value: 'Kapha',
    checked: false
  }],
  maxAnswers: 1,
  layout: 'single',
  colour: 'darkOrange'
}, {
  question: 'My dream hair would be',
  info: 'Select up to 5',
  answers: [{
    label: 'Thicker - it feels fine and sparse',
    value: 'Pitta',
    checked: false
  }, {
    label: 'Silkier \u2013 it feels rough and unruly',
    value: 'Vata',
    checked: false
  }, {
    label: 'Smoother \u2013 it frizzes easily',
    value: '',
    checked: false
  }, {
    label: 'Healthier \u2013 it\u2019s damaged and lacks shine',
    value: '',
    checked: false
  }, {
    label: 'Fuller \u2013 it lacks volume',
    value: 'Pitta',
    checked: false
  }, {
    label: 'Balanced \u2013 it\u2019s oily at the roots and dry at the ends',
    value: 'Kapha',
    checked: false
  }, {
    label: 'Manageable \u2013 it\u2019s naturally curly',
    value: 'Vata',
    checked: false
  }, {
    label: 'Longer \u2013 it never seems to grow and the ends keep breaking off',
    value: '',
    checked: false
  }, {
    label: 'Shinier \u2013 it\u2019s dull and flat',
    value: '',
    checked: false
  }, {
    label: 'Stronger \u2013 it needs moisture and resilience',
    value: 'Pitta',
    checked: false
  }],
  maxAnswers: 5,
  layout: 'double',
  colour: 'orange'
}, {
  question: 'My scalp is',
  info: 'Select all that apply',
  answers: [{
    label: 'Not something that bothers me',
    value: '',
    checked: false
  }, {
    label: 'Oily',
    value: '',
    checked: false
  }, {
    label: 'Flaky',
    value: '',
    checked: false
  }, {
    label: 'Dry',
    value: '',
    checked: false
  }, {
    label: 'Itchy or Sensitive',
    value: '',
    checked: false
  }],
  maxAnswers: 5,
  layout: 'single',
  colour: 'light'
}, {
  question: 'My hair care and styling regime',
  info: 'Select all that apply',
  answers: [{
    label: 'I wash and condition every day',
    value: '',
    checked: false
  }, {
    label: 'I use a treatment mask regularly',
    value: '',
    checked: false
  }, {
    label: 'I wash and condition 2 or more times a week',
    value: '',
    checked: false
  }, {
    label: 'I use a hair dryer every time I wash my hair',
    value: '',
    checked: false
  }, {
    label: 'I use straighteners every time I style my hair',
    value: '',
    checked: false
  }, {
    label: 'I never use conditioner',
    value: '',
    checked: false
  }, {
    label: 'I use styling products every day',
    value: '',
    checked: false
  }, {
    label: 'I brush my hair every day',
    value: '',
    checked: false
  }],
  maxAnswers: 10,
  layout: 'double',
  colour: 'grey'
}];